import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { DateWrapper, Input } from '@naf/input';
import { Text } from '@naf/text';
import { UserInteraction } from '@naf/user-interaction';
import { GridCol } from '@naf/grid';

const formFieldMaxWidth = '544px';
const twoColumnGap = spacing.space16;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${breakpoints.l}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 41px;
`;

const StyledForm = styled.form``;

const StyledGridCol = styled(GridCol)``;

const FirstHeading = styled(Text)`
  margin-top: 0;
  margin-bottom: ${spacing.space8};
  @media (min-width: ${breakpoints.m}) {
    margin-bottom: ${spacing.space16};
  }
`;

const SecondHeading = styled(Text)`
  margin-top: ${spacing.space24};
  margin-bottom: 0;

  @media (min-width: ${breakpoints.m}) {
    margin-bottom: 0;
  }
`;

const Heading = styled(Text)`
  margin-top: ${spacing.space48};
  margin-bottom: ${spacing.space8};
  @media (min-width: ${breakpoints.m}) {
    margin-bottom: ${spacing.space16};
  }
`;

const SubHeadingText = styled.p`
  margin-bottom: ${spacing.space32};
  @media (min-width: ${breakpoints.m}) {
    margin-bottom: 28px;
  }
`;

const FieldWrapper = styled.div`
  margin-top: ${spacing.space12};
`;

const FullWidthFieldWrapper = styled.div`
  margin-top: ${spacing.space12};
  width: 100%;
  max-width: ${formFieldMaxWidth};
`;

const ControllersWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${spacing.space12} ${twoColumnGap};
  width: 100%;
  max-width: ${formFieldMaxWidth};
  margin-top: ${spacing.space12};

  > div {
    min-width: 0;
    width: 100%;
  }

  > div > ${FieldWrapper} {
    margin-top: 0;
  }

  @media (max-width: ${breakpoints.m}) {
    grid-template-columns: 1fr;

    > div {
      width: 100%;
    }
  }
`;

const FirstName = styled.div`
  min-width: 0;

  @media (min-width: ${breakpoints.m}) {
    display: block;
  }
`;

const LastName = styled.div`
  min-width: 0;

  @media (min-width: ${breakpoints.m}) {
    display: block;
  }
`;

const BirthDateWrapper = styled(DateWrapper)`
  min-width: 0;
  width: 100%;

  > label {
    margin: 0;
  }

  > :nth-child(n + 2) {
    margin-right: 0;
  }

  > :nth-child(2),
  > :nth-child(3) {
    margin-right: ${spacing.space12};
  }
`;

const Zip = styled.div`
  min-width: 0;

  @media (min-width: ${breakpoints.m}) {
    display: block;
  }
`;

const City = styled.div`
  min-width: 0;

  @media (min-width: ${breakpoints.m}) {
    display: block;
  }
`;

const FullWidthTextField = styled(Input)`
  width: 100%;
  @media (min-width: ${breakpoints.m}) {
    max-width: ${formFieldMaxWidth};
  }
`;

const ResponsiveTextField = styled(Input)`
  width: 100%;
`;

const StyledUserInteraction = styled(UserInteraction)`
  max-width: 496px;
  margin-bottom: ${spacing.space24};
  margin-top: ${spacing.space48};

  @media (max-width: ${breakpoints.m}) {
    width: 100%;
    max-width: calc(100% - ${spacing.space48});
    margin-top: ${spacing.space24};
    margin-bottom: 0;
  }

  @media (max-width: ${breakpoints.s}) {
    width: 100%;
    max-width: calc(100% - ${spacing.space32});
  }
`;

const MessageWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: ${spacing.space32};

  @media (max-width: ${breakpoints.m}) {
    margin-bottom: 0;
  }
`;

const AlreadyAMemberWrapper = styled.div`
  margin-top: -${spacing.space32};
  margin-bottom: ${spacing.space32};
`;

const AddressWrapper = styled.div`
  width: 100%;
  max-width: 544px;

  > div {
    max-width: 100%;
    margin-top: ${spacing.space12};
  }
`;

const PhoneNumber = styled.div`
  min-width: 0;

  @media (min-width: ${breakpoints.m}) {
    display: block;
  }
`;

export default {
  ContentWrapper,
  FormWrapper,
  StyledForm,
  StyledGridCol,
  FirstHeading,
  SecondHeading,
  Heading,
  SubHeadingText,
  ControllersWrapper,
  FieldWrapper,
  FirstName,
  LastName,
  BirthDateWrapper,
  Zip,
  City,
  FullWidthTextField,
  ResponsiveTextField,
  StyledUserInteraction,
  MessageWrapper,
  AlreadyAMemberWrapper,
  AddressWrapper,
  FullWidthFieldWrapper,
  PhoneNumber,
};
